// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__51wAk","productName":"Table_productName__37J0n"};